import generateStyles from './generateStyles';

export default () => ({
    '&.slick-next': {
        ...generateStyles('right'),
    },
});
